import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhoneHandHold1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "phone-hand-hold-1" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.25,15l1.673-1.255a1.57,1.57,0,0,1,2.247.385h0a1.569,1.569,0,0,1,0,1.74l-1.645,2.467a4.5,4.5,0,0,1-2.073,1.682L6,21v2.25"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M9,9.75,5.4,11.291a4.5,4.5,0,0,0-2.363,2.364L1.864,16.4A4.5,4.5,0,0,0,1.5,18.174V23.25"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M9,14.438V3.75a3,3,0,0,1,3-3h7.5a3,3,0,0,1,3,3v16.5a3,3,0,0,1-3,3H12a3,3,0,0,1-3-3v-.5"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 10.214,
			y1: 18.75,
			x2: 22.5,
			y2: 18.75
		})
	]
});
export default SvgPhoneHandHold1;
